import React from "react";
import PageNotFoundIcon from "../assets/svgIcons/PageNotFoundIcon";
import StyledText from "../components/StyledComponents/StyledText";
import StyledButton from "../components/StyledComponents/StyledButton";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="p-md-5 md-md-5 mt-5 pt-5">
      <div className="d-flex align-items-center flex-column justify-content-center p-2 p-md-5 m-2 md-md-5">
        <PageNotFoundIcon className="px-4 px-md-0" />
        <StyledText
          $fontSize="1.1rem"
          $fontWeight="600"
          className="my-4 mt-md-5"
        >
          Page Not Found
        </StyledText>
        <StyledText
          $fontSize="0.9rem"
          className="mb-3 mb-md-4 text-center"
          color="textColor"
        >
          The page you are looking for does not exist.
        </StyledText>
        <StyledButton
          _variant="primaryGradiant"
          className="d-flex align-items-center mt-3 px-5"
          onClick={() => navigate("/")}
        >
          <StyledText $fontSize="0.9rem" $fontWeight="600" color="white">
            Refresh Page
          </StyledText>
        </StyledButton>
      </div>
    </div>
  );
};

export default PageNotFound;
